<template>
  <b-card no-body >
    <b-card-body class="p-1">
      <div class="d-inline-flex align-items-center w-100">
        <b-button
          variant="gradient-primary"
          size="sm"
          class="mr-1"
          :disabled="loading2"
          @click="traerEmpresas"
        >
          <feather-icon icon="RefreshCwIcon" />
        </b-button>

        <b-button
          v-if="$can('create', 'trabajaenagrovision')"
          variant="gradient-primary"
          size="sm"
          class="mr-1"
          :disabled="loading2"
          @click="descargarFile"
          style="min-width: 150px; white-space: nowrap;"
        >
          <span v-if="loading2">
            Generando Archivo..&emsp;<b-spinner style="width: 16px; height: 16px;" />
          </span>
          <span v-else class="d-flex align-items-center">
            <feather-icon icon="ExternalLinkIcon" class="mr-1" />
            <span>Exportar Excel</span>
          </span>
        </b-button>

        <feather-icon
            icon="CalendarIcon"
            class="mr-1"
          />

          <div class="position-relative d-flex align-items-center mr-1">
            <flat-pickr
              v-model="fechaRango"
              :config="configFlatpickr"
              class="form-control"
              style="height: 31px;"
              placeholder="Selecciona un rango de fechas"
            />
            <b-button
              variant="primary"
              size="sm"
              class="ml-1"
              @click="traerEmpresas"
              >
              Filtrar
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              class="ml-1"
              @click="limpiarFecha"
              title="Limpiar Filtro"
            >
              <feather-icon icon="XCircleIcon"/>
            </b-button>
          </div>
      </div>
    </b-card-body>
    <b-table
        hover
        responsive
        small
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="cPaginacion"
        :busy="loading"
    >
      <template #table-busy>
        <div class="text-center text-dark my-1">
          <b-spinner class="align-middle"></b-spinner> &emsp;
          <strong>Obteniendo datos...</strong>
        </div>
      </template>
      <template #cell(estado)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
      <template #cell(created)="data">
        <span class="text-nowrap">
          {{
            new Date(data.value).toLocaleString('pe-PE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              localeMatcher: 'best fit',
              hour: '2-digit',
              minute: '2-digit',
              timeZone: 'America/Lima'
            })
          }}
        </span>
      </template>
      <template #cell(nombres)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(apellidos)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(departamento)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(provincia)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(distrito)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(centro_poblado)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(correo)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
        />

      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

    <b-modal
        id="modalRegistro"
        v-model="estadoModal"
        :title="infoModal.title"
        :ok-title="infoModal.boton"
        cancel-variant="outline-secondary"
        cancel-title="Cancelar"
        @hidden="resetModal"
        @ok="okModal"
        centered
    >
      <form
          ref="form"
          @submit.stop.prevent="enviarFormulario"
      >
        <b-row>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Código"
                label-for="codigo"
                invalid-feedback="Código es requerido"
            >
              <b-form-input
                  id="codigo"
                  placeholder="Código"
                  v-model="codigo"
                  :state="validacion"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Nombre"
                label-for="nombre"
                invalid-feedback="Nombre es requerido"
            >
              <b-form-input
                  id="nombre"
                  placeholder="Nombre"
                  v-model="nombre"
                  :state="validacion"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Descripción"
                label-for="descrip"
                invalid-feedback="Descripción es requerido"
            >
              <b-form-input
                  id="descrip"
                  placeholder="Descripción"
                  v-model="descrip"
                  :state="validacion"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="Estado"
                label-for="estado"
                invalid-feedback="Código AGV es requerido"
            >
              <v-select
                  id="estado"
                  v-model="estado"
                  label="text"
                  :options="estados"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </b-card>
</template>

<script>
import axiosIns from '../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish } from 'flatpickr/dist/l10n/es.js'

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    flatPickr
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 15,
      pageOptions: [15, 25, 50],
      totalRows: 1,
      currentPage: 1,
      sortBy: 'id',
      sortDesc: true,
      sortDirection: 'desc',
      filter: null,
      filterOn: [],
      fechaRango: '',
      configFlatpickr: {
        mode: 'range',
        locale: Spanish,
        dateFormat: 'd-m-Y',
      },
      estadoModal: false,
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        /*
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },

        {
          key: 'cod',
          label: 'Código',
          sortable: true
        },
        */
        {
          key: 'dni',
          label: 'DNI',
          sortable: true
        },
        {
          key: 'nombres',
          label: 'Nombres',
          sortable: true
        },
        {
          key: 'apellidos',
          label: 'Apellidos',
          sortable: true
        },
        {
          key: 'celular',
          label: 'celular',
          sortable: true
        },
        {
          key: 'n_hijos',
          label: 'N° de Hijos',
          sortable: true
        },
        {
          key: 'n_campanas',
          label: 'N° de Campañas',
          sortable: true
        },
        {
          key: 'departamento',
          label: 'departamento',
          sortable: true
        },
        {
          key: 'provincia',
          label: 'provincia',
          sortable: true
        },
        {
          key: 'distrito',
          label: 'distrito',
          sortable: true
        },
        {
          key: 'centro_poblado',
          label: 'centro poblado',
          sortable: true
        },
        {
          key: 'paradero',
          label: 'paradero',
          sortable: true
        },
        {
          key: 'created',
          label: 'fecha de registro',
          sortable: true
        },
      ],
      items: [],
      status: [
        {
          0: 'Activo',
          1: 'Inactivo',
        },
        {
          0: 'light-success',
          1: 'light-danger',
        }
      ],
      validacion: null,
      estados: [
        {value: 0, text: "Activo"},
        {value: 1, text: "Inactivo"}
      ],
      codigo: '',
      descrip: '',
      nombre: '',
      estado: {value: 0, text: "Activo"},
      id: 0,
      tipo: 0,
      loading2: false,
      loading: false,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.traerEmpresas();
  },
  methods: {
    limpiarFecha() {
      this.fechaRango = null; // Limpia el rango de fechas
      this.traerEmpresas(); // Refresca los datos si es necesario
    },

    traerEmpresas() {
      let yo = this;
      yo.loading = true;

      let params = {};

      // Verificar si hay selección de fechas
      if (yo.fechaRango && yo.fechaRango.length > 0) {
        // Dividir usando el separador " a "
        let fechas = yo.fechaRango.split(' a ');

        // Convertir las fechas al formato 'YYYY-MM-DD' para el backend
        const formatoFecha = (fecha) => {
          let partes = fecha.split('-'); // formato 'dd-mm-yyyy'
          return `${partes[2]}-${partes[1]}-${partes[0]}`; // Retornar 'yyyy-mm-dd'
        };

        if (fechas.length === 1) {
          // Solo una fecha seleccionada
          let fecha = formatoFecha(fechas[0]);
          params.fecha_desde = fecha;
          params.fecha_hasta = fecha;
        } else if (fechas.length === 2) {
          // Rango de fechas seleccionado
          params.fecha_desde = formatoFecha(fechas[0]);
          params.fecha_hasta = formatoFecha(fechas[1]);
        }
      }

      // Configuración de la solicitud
      let config = {
        method: 'get',
        url: '/trabajaenagrovision/registrostea/',
        params: params,
      };

      axiosIns(config)
        .then(function (response) {
          yo.items = response.data;
          yo.totalRows = yo.items.length;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loading = false;
        });
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    mostrarModal(tipo, id, codigo, descrip, nombre, estado){
      this.tipo = tipo
      this.estadoModal = true

      if (this.tipo === 1 ){
        this.infoModal.title = 'Registrar Empresa'
        this.infoModal.boton = 'Registar'
      }
      else if (this.tipo === 2 ){
        this.infoModal.title = 'Editar Empresa'
        this.infoModal.boton = 'Editar'

        this.id = id
        this.codigo = codigo
        this.descrip = descrip
        this.nombre = nombre

        this.estado = {value: parseInt(estado), text: estado === '0' ? 'Activo' : 'Inactivo'}
      }
    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
        component: ToastificationContent,
        props:{
          title: titulo,
          icon: icono,
          text: texto,
          variant: variante
        }
      },
      {
        timeout: 5000
      })
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },

    validarFormulario() {
      const valid = this.$refs.form.checkValidity()
      this.validacion = valid
      return valid
    },

    resetModal() {
      this.codigo = ''
      this.descrip = ''
      this.nombre = ''
      this.estado = {value: 0, text: "Activo"}
      this.validacion = null
      this.resetInfoModal()
    },

    okModal(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.enviarFormulario()
    },

    enviarFormulario() {
      // Exit when the form isn't valid
      if (!this.validarFormulario()) {
        return
      }

      // Hide the modal manually
      this.$nextTick(() => {
        var yo = this

        var data = JSON.stringify({
          "cod": yo.codigo,
          "descrip": yo.descrip,
          "nombre": yo.nombre,
          "estado": yo.estado.value.toString()
        });

        var url = this.tipo === 1 ? '/configuracion/empresas/crear/' : '/configuracion/empresas/editar/'+this.id
        var metodo = this.tipo === 1 ? 'post' : 'patch'

        var config = {
          method: metodo,
          url: url,
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        };

        axiosIns(config)
            .then(function (response) {

              if (response.status === 201 || response.status === 200){
                yo.traerEmpresas();

                if (yo.tipo === 1){
                  yo.mostrarNotificacion('Registro creado', 'CheckIcon', 'La empresa ' + response.data.cod + ' ha sido registrado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Registro modificado', 'CheckIcon', 'La empresa ' + yo.codigo + ' ha sido modificado correctamente', 'success')
                }

              }else{
                yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
              }

            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
            });

        this.estadoModal = false
      })
    },

    eliminarRegistro(id, empresa){
      var yo = this

      this.$swal({
        title: '¡Alerta!',
        text: "¿Seguro que quieres eliminar la empresa " + empresa + "?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          var config = {
            method: 'delete',
            url: '/configuracion/empresas/eliminar/' + id,
            headers: { }
          };

          axiosIns(config)
              .then(function (response) {
              if (response.status === 204){
                  yo.traerEmpresas();
                  yo.mostrarNotificacion('Registro eliminado', 'CheckIcon', 'La empresa ha sido eliminado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
                }
              })
              .catch(function (error) {
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
              });
        }
      })
    },

    descargarFile(){
      var yo = this
      this.loading2 = true
      var config = {
        method: 'post',
        url: '/trabajaenagrovision/registrostea/exportar/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              console.log("Enviado")

              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'RegistrosTEA.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Archivo creado',
                  icon: 'CheckIcon',
                  text: 'El archivo se creó satisfactoriamente.',
                  variant: 'success',
                },
              },
                  {
                    position: 'top-center',
                  })
            }
            else if(response.status === 204){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'No existen registros',
                  icon: 'AlertTriangleIcon',
                  text: 'No se encontraron registros con los parámetros solicitados.',
                  variant: 'warning',
                },
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loading2 = false
          });
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
